import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-verify-otp-message-dialogue',
  templateUrl: './verify-otp-message-dialogue.component.html',
  styleUrl: './verify-otp-message-dialogue.component.scss'
})
export class VerifyOtpMessageDialogueComponent {
  title:any;
  Description:any;
  fontIcon : any;
  IsApproval: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<VerifyOtpMessageDialogueComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    
  }
  ngOnInit(){
   this.title = this.data.title;
   this.Description = this.data.Description
   this.fontIcon = this.data.fontIcon
   this.IsApproval = this.data.IsApproval;
  }
  close(): void {
    this.dialogRef.close(true);
  }
}
